import {Row,Col,Card,Table,Button,Modal,Form,Input,Tag,Upload,Image,message,Tooltip} from "antd";
import apiPath from "../../../constants/apiPath";
import React, { useState, useEffect, useRef } from "react";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import Main from "../../../components/layout/Main";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { UploadOutlined } from '@ant-design/icons';
import SingleImageUpload from "../../../components/SingleImageUpload";
import { uploadFile } from 'react-s3';
import moment from 'moment';
import ShowTotal from "../../../components/ShowTotal";
import notfound from "../../../assets/images/not_found.png"

const Search = Input.Search;

const S3_BUCKET = 'carwash-s3';
const REGION = 'eu-north-1';
const ACCESS_KEY = 'AKIA5FTZEKCY6QNUX77Q';
const SECRET_ACCESS_KEY = '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';

const config = {
  dirName: "avatar",
  bucketName: S3_BUCKET,
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
}

function Index() {

  const { request } = useRequest()
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const { confirm } = Modal;

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button >Are you sure you want change the status ?</Button>,
        onOk() {
          statusChange(record)
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }, 5);
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (_, { image }) => <Image width={60} height={50} src={ image?? notfound}/>
    },
    {
      title: "Status",
      key: "is_active",
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'Inactive',
          value: false,
        },
      ],
      render: (_, { is_active, _id }) => {
        let color = is_active ? 'green' : 'red';
        return ( <div className="pointer"><Tag onClick={(e) => showConfirm(_id)} color={color} key={is_active}>{is_active ? "Active" : "Inactive"}</Tag></div> );
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return (
          moment(created_at).format('DD-MM-YYYY')
        );
      },
    },
    {
      title: "Action",
      fixed: 'right',
      render: (_, record) => {
        return (
          <>
            <div>
            <Tooltip title="Update Avatar" color={"purple"} key={"updateavatar"}>
              <Button onClick={() => {
                setSelected(record)
                setVisible(true)
              }}>
                <i className="fa fa-light fa-pen"></i>
              </Button>
              </Tooltip>
            </div>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setLoading(true)
    fetchData(pagination)
  }, [refresh])
  
  const statusChange = (record) => {
    setLoading(true);
    request({
      url: apiPath.statusCarAvatar + "/" + record,
      method: 'GET',
      onSuccess: (data) => {
        setRefresh(prev => !prev)
        setLoading(false);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR)
      }
    })
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.is_active : null
    request({
      url: apiPath.listCarAvatar + `?status=${filterActive ? filterActive.join(',') : ''}&page=${pagination ? pagination.current : 1}&limit=${pagination ? 10 : 10}`,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false)
        const list = data.data.list.docs.map(item => ({ ...item, key: item._id }))
        setList(list);
        setPagination(prev => ({ current: pagination.current, total: data.data.list.totalDocs }))
      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  }

  return (
    <Main>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Avatar Management"
              extra={
                <Button onClick={(e) => setVisible(true)}>Add Avatar</Button>
              }
            >
              <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{ defaultPageSize: 10, responsive: true, total: pagination.total, showSizeChanger: true, showQuickJumper: true, pageSizeOptions: ['10', '20', '30', '50']}}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && <AddFrom show={visible} hide={() => { setSelected(); setVisible(false) }} data={selected} refresh={() => setRefresh(prev => !prev)} />}
    </Main>
  );
}

const AddFrom = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const [file, setFile] = useState([]);
  const [avatar, setAvatar] = useState([]);
  const { request } = useRequest()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setAvatar([])
    if (!data) return
    form.setFieldsValue({ ...data })
    data.image ? setFile([data.image]) : setFile([]);
    data.image ? setAvatar([data.image]) : setAvatar([]);
  }, [data])
  
/* 
  const onCreate = (values) => {
    if (file.length <= 0) return ShowToast('Please select the avatar Image ', Severty.ERROR)
    const payload = {}
    setLoading(true)
    payload.image = file.length > 0 ? file[0].url : '';
    request({
      url:  `${data ? apiPath.addEditCarAvatar + "/" + data._id : apiPath.addEditCarAvatar}`,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false)
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS)
          hide()
          refresh()
        } else {
          ShowToast(data.message, Severty.ERROR)
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR)
        setLoading(false)
      },
    })
  };
 */

   const onCreate = (values) => {
     if (values.image.file.status === "removed") {
       setFile([]);
       return ShowToast("Please select the avatar image! ", Severty.ERROR);
     }
     const formData = new FormData();
     formData.append("image", file);
     setLoading(true);
     request({
       url: `${
         data ? apiPath.addEditCarAvatar + "/" + data._id : apiPath.addEditCarAvatar
       }`,
       method: "POST",
       data: formData,
       onSuccess: (data) => {
         setLoading(false);
         if (data.status) {
           ShowToast(data.message, Severty.SUCCESS);
           hide();
           refresh();
         } else {
           ShowToast(data.message, Severty.ERROR);
         }
       },
       onError: (error) => {
         ShowToast(error.response.data.message, Severty.ERROR);
         setLoading(false);
       },
     });
   };
  return (
    <Modal
      visible={show}
      title={`${data ? "Edit Avatar" : "Create a New Avatar"}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row>
          <Col span={24}>
            <SingleImageUpload
              label="Upload Avatar"
              dataImage={data}
              onChange={(file) => {
                setFile(file);
              }}
              rules={[{ required: true, message: "Please Enter the Avatar!" }]}
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default Index;
